import $ from 'jquery'
import BhubStepForm from './StepForm'
import HotelForm from './HotelForm'

$('.bhub-step-booking-form').each(function () {
  const el = $(this)
  new BhubStepForm(el)
})

$('.bhub-hotel-form').each(function () {
  const el = $(this)
  new HotelForm(el)
})
